import { AlgoliaSearchProvider } from '@components/AlgoliaSearch/AlgoliaSearchProvider'

export const withAlgoliaSearch = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <AlgoliaSearchProvider>
        <WrappedComponent {...props} />
      </AlgoliaSearchProvider>
    )
  }
}
